module.exports = __webpack_public_path__ + "static/dashboard_intro_api@2x-0f9a84d0e59cb50aa25c59fb1565ad4c.png";